

























































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import FeedbackIcon from './FeedbackIcon.vue';
import { Prop } from 'vue-property-decorator';
import { user, feedbacks } from '@/modules/shared/shared/store/namespaces';
import { GET_USER_ID, IS_EMPLOYEE } from '@/modules/users/store/user.getters';
import { FeedbacksActions } from '../store/feedbacks.actions';
import { Feedback } from '@/modules/feedbacks/domain/feedback';
import * as rules from '@/modules/shared/shared/domain/rules';
import { FeedbackTypes } from '@/modules/feedbacks/domain/feedback-types';

@Component({
    name: 'create-feedback-modal',
    components: {
        FeedbackIcon,
    },
})
export default class FeedbackModal extends Vue {
    @Prop({ required: true })
    smallScreen!: boolean;

    dialog: boolean = false;
    timeout: number = 6000;
    rules: any = rules;

    feedbackTypeLikes: number = FeedbackTypes.LIKES.id;
    feedbackTypeSuggestions: number = FeedbackTypes.SUGGESTIONS.id;
    feedbackTypeImprovements: number = FeedbackTypes.IMPROVEMENTS.id;
    feedbackTypeAppreciations: number = FeedbackTypes.APPRECIATIONS.id;

    feedback: Feedback = {
        appreciation: undefined,
        feedbackType: undefined,
        content: null,
        user: -1,
    };

    isFormValid: boolean = false;

    sendingFeedback: boolean = false;
    feedbackSentSuccessfully: boolean = false;
    feedbackSentUnsuccessfully: boolean = false;

    LIKES_MIN_THRESHOLD: number = 4;
    IMPROVEMENT_MIN_THRESHOLD: number = 1;

    get getFeedbackQuestion(): { placeholder: string; icon?: string } {
        let feedbackQuestion = { placeholder: '', icon: '' };

        const appreciation: number = this.feedback.appreciation ?? 0;

        if (appreciation >= this.LIKES_MIN_THRESHOLD) {
            feedbackQuestion.placeholder = '¿Qué te gusta del portal?';
            feedbackQuestion.icon = 'mdi-emoticon-happy-outline';
        } else if (appreciation >= this.IMPROVEMENT_MIN_THRESHOLD) {
            feedbackQuestion.placeholder = '¿Qué podemos mejorar?';
            feedbackQuestion.icon = 'mdi-hand-heart-outline';
        } else {
            feedbackQuestion.placeholder = '¿Qué funcionalidades te gustaría ver en el portal?';
        }

        return feedbackQuestion;
    }

    selectFeedbackType(feedbackTypeId: number): void {
        this.feedback.feedbackType = feedbackTypeId;
    }

    async sendFeedback(): Promise<void> {
        this.feedback.user = this.GET_USER_ID;
        this.sendingFeedback = true;

        if (this.feedback.feedbackType === this.feedbackTypeSuggestions) {
            this.feedback.appreciation = undefined;
        } else {
            this.feedback.appreciation = this.feedback.appreciation ?? 0;

            if (this.feedback.appreciation >= this.LIKES_MIN_THRESHOLD) {
                this.feedback.feedbackType = this.feedbackTypeLikes;
            } else if (this.feedback.appreciation >= this.IMPROVEMENT_MIN_THRESHOLD) {
                this.feedback.feedbackType = this.feedbackTypeImprovements;
            } else {
                this.feedback.feedbackType = this.feedbackTypeImprovements;
            }
        }

        const failed = await this.createFeedback(this.feedback);

        this.sendingFeedback = false;

        if (!failed) {
            this.feedbackSentSuccessfully = true;
        } else {
            this.feedbackSentUnsuccessfully = true;
        }

        this.restoreFeedbackToInitialState();
        this.dialog = false;
    }

    restoreFeedbackToInitialState(): void {
        this.feedback = {
            appreciation: undefined,
            feedbackType: undefined,
            content: null,
            user: -1,
        };
    }

    open(): void {
        this.dialog = true;
    }

    cancel(): void {
        this.restoreFeedbackToInitialState();
    }

    closeDialog(): void {
        this.cancel();
        this.dialog = false;
    }

    @user.Getter(IS_EMPLOYEE) IS_EMPLOYEE;
    @user.Getter(GET_USER_ID) GET_USER_ID;
    @feedbacks.Action(FeedbacksActions.CREATE_FEEDBACK) createFeedback!: (
        feedback: Feedback,
    ) => Promise<RequestResponse>;
}
